import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import HigashikawaPage from './pages/HigashikawaPage';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="higashikawa" element={<HigashikawaPage />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;